<div class="page">
	<div class="content">
		<div class="content-header">
			<h1 class="title-primary">{{'LoginMainTitle' | cpLoginTranslate | async}}</h1>
			<h2 class="title-secondary">{{'LoginSecondaryTitle' | cpLoginTranslate | async}}</h2>
		</div>

		<form class="form-container" [formGroup]="formControls" autocomplete="off" action="" (keydown)="onKeyDown($event)">
			<div class="label-wrapper">
				<label for="userName">{{'UserName' | cpLoginTranslate | async}}:</label>
			</div>

			<div class="input-wrapper">
				<input #inputField autofocus type="text" [(ngModel)]="userName" id="userName" formControlName="userName" autocomplete="off" autocorrect="off" autocapitalize="off"
					   [ngClass]="isUserNameFilled === 'invalid' ? 'input-invalid': ''" aria-required="true" />

				<label [ngStyle]="{'visibility':isUserNameFilled === 'invalid' ? 'visible' : 'hidden'}" class="text-invalid">
					{{'FillUserName' | cpLoginTranslate | async}}
				</label>
			</div>

			<div class="label-wrapper">
				<label for="password">{{'Password' | cpLoginTranslate | async}}:</label>
			</div>

			<div class="input-wrapper">
				<input #Password [type]="!passwordVisible ? 'password' : 'text'" [(ngModel)]="password" id="password" formControlName="password" autocomplete="off" autocorrect="off" autocapitalize="off"
					   [ngClass]="isPasswordFilled === 'invalid' ? 'input-invalid': ''" aria-required="true" />
				<span class="field-icon-wrapper">
					<i class="field-icon"
						[ngClass]="passwordVisible ? 'pp-icon-hide': 'pp-icon-show'"
						cpClickableElement [elementDescription]="(passwordVisible ? 'HidePassword' : 'ShowPassword') | cpActionTranslate | async"
						elementRole="switch"
						[attr.aria-checked]="passwordVisible"
						(click)="togglePasswordVisibility()">

					</i>
				</span>

				<label [ngStyle]="{'visibility':isPasswordFilled === 'invalid' ? 'visible' : 'hidden'}" class="text-invalid">
					{{'FillPassword' | cpLoginTranslate | async}}
				</label>
			</div>

			<cp-button class="login-button primary-button call-to-action" captionToTranslate="LogInNow.Login.PP"
					   [disabled]="loginInProgress" (onClick)="login()">

			</cp-button>

			<div class="forgot-password-wrapper">
				<a routerLink="." class="forgot-password-link" (click)="!loginInProgress && doForgotPassword()">{{'ForgotPassword' | cpLoginTranslate | async}}</a>
			</div>

			<div *ngIf="!errorText1" [ngStyle]="{'visibility':loginInProgress ? 'visible' : 'hidden'}" class="progress-spinner">
				<div class="loading-image"></div>
			</div>

			<app-information-box
				[text1]="errorText1"
				[text1Args]="errorText1Args"
				[text2]="errorText2"
				[text3]="errorText3"
				[actionTextIndex]="errorActionTextIndex"
				[icon]="'pp-icon-error'"
				[contactInfo]="contactInfoData"
				(onAction)="errorAction()">
			</app-information-box>

			<div class="dont-have-account-wrapper">
				<label>{{'DontHaveAccount' | cpLoginTranslate | async}}</label>
			</div>

			<cp-button *ngIf="allowCreateAccount" class="secondary-button call-to-action" captionToTranslate="CreateAccount.Login.PP"
					   [disabled]="loginInProgress" (onClick)="newAccount()"></cp-button>
		</form>

		<ng-template #changePasswordTitle>
			<div class="popup-title-container contact-us">
				<h1 class="popup-title-text" id="change-password-title">{{'PasswordExpired' | cpLoginTranslate | async}}</h1>
				<i class="pp-icon-close popup-close" cpClickableElement [elementDescription]="'Close' | cpActionTranslate | async" (click)="popupWindowService.closeLatestPopup()"></i>
			</div>
		</ng-template>

		<aside class="version-wrapper">
			<span class="release side">{{'Release' | cpLabelTranslate:[releaseVersion] | async}}</span>
			<span class="separator">|</span>
			<span class="version side">{{'CommercialVersion' | cpLabelTranslate:[commercialVersion] | async}}</span>
		</aside>
	</div>

	<ng-template #contactUsTitle>
		<div class="popup-title-container contact-us">
			<h1 class="popup-title-text" id="contact-us-title">{{'ContactUs' | cpTitleTranslate | async}}</h1>
			<i class="pp-icon-close popup-close" cpClickableElement [elementDescription]="'Close' | cpActionTranslate | async" (click)="popupWindowService.closeLatestPopup()"></i>
		</div>
	</ng-template>

	<ng-template #accessibilityStatementTitle>
		<div class="popup-title-container language-selection">
			<h1 class="popup-title-text" id="accessibility-statementTitle">{{'AccessibilityStatement' | cpTitleTranslate | async}}</h1>
			<i class="pp-icon-close popup-close" cpClickableElement [elementDescription]="'Close' | cpActionTranslate | async" (click)="popupWindowService.closeLatestPopup()"></i>
		</div>
	</ng-template>

	<ng-template #aboutTitle>
		<div class="popup-title-container about">
			<h1 class="popup-title-text" id="about-title">{{'About' | cpTitleTranslate | async}}</h1>
			<i class="pp-icon-close popup-close" cpClickableElement [elementDescription]="'Close' | cpActionTranslate | async" (click)="popupWindowService.closeLatestPopup()"></i>
		</div>
	</ng-template>

	<ng-template #termsTitle>
		<div class="popup-title-container terms">
			<h1 class="popup-title-text" id="terms-title">{{'Terms' | cpTitleTranslate | async}}</h1>
			<i class="pp-icon-close popup-close" cpClickableElement [elementDescription]="'Close' | cpActionTranslate | async" (click)="popupWindowService.closeLatestPopup()"></i>
		</div>
	</ng-template>

	<aside class="about-terms-wrapper">
		<span class="about side"><a routerLink="." (click)="showAboutPage()">{{'About' | cpActionTranslate | async}}</a></span>
		<span class="separator">|</span>
		<span class="terms side"><a routerLink="." (click)="showTermsPage()">{{'Terms' | cpActionTranslate | async}}</a></span>
	</aside>

	<footer class="footer">
		<div><a routerLink="." (click)="showContactUsPage()">{{'ContactUs' | cpActionTranslate | async}}</a> {{'IfYouNeedHelp' | cpLabelTranslate | async}}</div>
		<div><a routerLink="." (click)="showAccessibilityStatementPage()">{{'AccessibilityStatement' | cpActionTranslate | async}}</a></div>
	</footer>
</div>
